// Generated by CoffeeScript 2.7.0
// 多次填写设置和后台存储的数据是反义的，不好结构化处理
// 在传入和传出时需要处理
var ResponseSetting, user_fill_setting_comp;

import DateTimePickerPopover from 'trunks/vue/admin/components/date_time_picker_popover.js';

user_fill_setting_comp = {
  response_required: {
    label: '必须填写',
    tip: '开启时，会提示接收者必填',
    enable: false
  },
  anonymous_allowed: {
    label: '公开收集',
    tip: `<div>开启时，通过分享、转发等操作只要用户收到都可以填写</div>
<div>关闭时，只有该表单的接收者才能填写表单</div>`,
    enable: false
  },
  multiple_submit: {
    label: '多次填写',
    tip: `<div>开启时，不限制用户填写的次数</div>
<div>关闭时，一个用户（含微信用户）只能填写一次，但匿名用户不受限制</div>`,
    enable: false
  },
  step_renderable: {
    label: '分步填写',
    tip: `<div>开启时，每个表项以单独一页的形式展示让用户填写，可通过快捷按钮切换前后的填写内容</div>
<div>关闭时，所有表项在同一页面进行填写，可滑动查看前后的填写内容</div>`,
    enable: false
  },
  responses_sharing: {
    label: '填写记录相互可见',
    tip: `<div>开启时，接收者可以看到其他接收者填写的填写记录</div>
<div>关闭时，用户只能查看到自己的填写记录</div>`,
    enable: false
  },
  enable_appendable: {
    label: '自动追加表单',
    tip: '开启时，将自动向新加入接收组织的成员追加该表单',
    enable: false
  }
};

export default ResponseSetting = {
  components: {
    'datetime-picker': DateTimePickerPopover
  },
  props: {
    initialSettings: {
      type: Object,
      default: function() {
        return {};
      }
    },
    initialCloseSettings: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    var ref, ref1;
    return {
      responseSettings: _.reduce(user_fill_setting_comp, (memo, value, key) => {
        memo[key] = key === 'multiple_submit' ? _.extend(value, {
          enable: _.has(this.initialSettings, 'submit_once') ? !this.initialSettings['submit_once'] : false
        }) : _.extend(value, {
          enable: this.initialSettings[key]
        });
        return memo;
      }, {}),
      responses_limit: this.initialCloseSettings.responses_limit,
      closed_at: ((ref = this.initialCloseSettings) != null ? ref.closed_at : void 0) && new Date((ref1 = this.initialCloseSettings) != null ? ref1.closed_at : void 0)
    };
  },
  template: `<div class="response-settings">
  <div class="tab-section message-options">
    <h4 class="tab-section-title">用户可以</h4>
    <div class="tab-section-content">
      <div class="options">
        <label class="option-item" v-for='(setting, key) in responseSettings' :key='key'>
          <input type="checkbox" hidden='true' v-model='setting.enable' />
          <i class="slp-square-o"></i>
          <span class="option-label">
            <span>{{ setting.label }}</span>
            <span class="slp-tooltip right">
              <span class="slp-tooltip-content" v-html='setting.tip'></span>
              <i class="slp-question"></i>
            </span>
          </span>
        </label>
      </div>
    </div>
  </div>
  <div class="tab-section message-close-setting">
    <h4 class="tab-section-title">表单自动关闭</h4>
    <div class="tab-section-content">
      <div class="form-field-group inline">
        <div class="form-field">
          <div class="form-field-head">
            <div class="form-field-title">达到最大填写记录数:</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input type="number" class="form-field-value" v-model='responses_limit' placeholder='请输入' />
            </div>
          </div>
        </div>
        <div class="form-field">
          <div class="form-field-head">
            <div class="form-field-title">达到时间点:</div>
          </div>
          <div class="form-field-input-container">
            <datetime-picker position='top'
                             customClass='content'
                             :initValue='closed_at'
                             @valueChanged='updateCloseAt' />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    return this.closed_at;
  },
  methods: {
    getData: function() {
      var ref;
      return {
        responseSettings: _.reduce(this.responseSettings, function(memo, value, key) {
          if (key === 'multiple_submit') {
            memo.submit_once = !value.enable;
          } else {
            memo[key] = value.enable;
          }
          return memo;
        }, {}),
        closeSetting: {
          responses_limit: this.responses_limit,
          closed_at: (ref = this.closed_at) != null ? ref.strftime('YYYY-MM-DD hh:mm') : void 0
        }
      };
    },
    updateCloseAt: function(date) {
      return this.closed_at = date;
    }
  }
};
